/* auto-generated, DO NOT EDIT! */
export const Animations = {
  Loading: require("./animations/loading.svg").default,
};

export const Callout = {
  Bulb: require("./callout/bulb.svg").default,
  Heart: require("./callout/heart.svg").default,
  LevelUp: require("./callout/level-up.svg").default,
};

export const Faces = {
  Face1: require("./faces/face-1.svg").default,
  Face2: require("./faces/face-2.svg").default,
  Face3: require("./faces/face-3.svg").default,
  Face4: require("./faces/face-4.svg").default,
  Face5: require("./faces/face-5.svg").default,
  Face6: require("./faces/face-6.svg").default,
};

export const Icons = {
  GDPRCompliant: require("./icons/GDPR_compliant.svg").default,
  AutomatedShorlisting: require("./icons/automated_shorlisting.svg").default,
  CandidatesInformed: require("./icons/candidates_informed.svg").default,
  Customisation: require("./icons/customisation.svg").default,
  Endorsement: require("./icons/endorsement.svg").default,
  Blockchain: require("./icons/higher_icon_blockchain.svg").default,
  BlockchainReversed: require("./icons/higher_icon_blockchain_reversed.svg")
    .default,
  Calendar: require("./icons/higher_icon_calendar.svg").default,
  CalendarBlue: require("./icons/higher_icon_calendar_blue.svg").default,
  CalendarReversed: require("./icons/higher_icon_calendar_reversed.svg")
    .default,
  Chat: require("./icons/higher_icon_chat.svg").default,
  ChatBlue: require("./icons/higher_icon_chat_blue.svg").default,
  ChatReversed: require("./icons/higher_icon_chat_reversed.svg").default,
  Clipboard: require("./icons/higher_icon_clipboard.svg").default,
  ClipboardMono: require("./icons/higher_icon_clipboard_mono.svg").default,
  ClipboardReversed: require("./icons/higher_icon_clipboard_reversed.svg")
    .default,
  Network: require("./icons/higher_icon_network_.svg").default,
  NetworkReversed: require("./icons/higher_icon_network_reversed.svg").default,
  Padlock: require("./icons/higher_icon_padlock.svg").default,
  PadlockReversed: require("./icons/higher_icon_padlock_reversed.svg").default,
  Phone: require("./icons/higher_icon_phone.svg").default,
  PhoneReversed: require("./icons/higher_icon_phone_reversed.svg").default,
  Roi: require("./icons/higher_icon_roi.svg").default,
  RoiReversed: require("./icons/higher_icon_roi_reversed.svg").default,
  Wallet: require("./icons/higher_icon_wallet.svg").default,
  WalletReversed: require("./icons/higher_icon_wallet_reversed.svg").default,
  LeanestFeesPossible: require("./icons/leanest_fees_possible.svg").default,
  LinkedinIntegration: require("./icons/linkedin_integration.svg").default,
  ReachOutDirectly: require("./icons/reach_out_directly.svg").default,
  RealTimeCollaboration: require("./icons/real-time_collaboration.svg").default,
  SecureByDefault: require("./icons/secure_by_default.svg").default,
};

export const Images = {
  BeCertain: require("./images/be-certain.svg").default,
  BeEfficient: require("./images/be-efficient.svg").default,
  BeHuman: require("./images/be-human.svg").default,
  BrandarrowsBackgroundImageTrans:
    require("./images/brandarrows-background-image-trans.png").default,
  BrandarrowsBackgroundImageWhite:
    require("./images/brandarrows-background-image-white.svg").default,
  BrandballoonFive: require("./images/brandballoon-five.png").default,
  BrandballoonFour: require("./images/brandballoon-four.png").default,
  BrandballoonPrimary: require("./images/brandballoon-primary.png").default,
  BrandballoonThree: require("./images/brandballoon-three.png").default,
  BrandballoonTwo: require("./images/brandballoon-two.png").default,
  BrandballoonsBackgroundImage:
    require("./images/brandballoons-background-image.png").default,
  CharitableDonations: require("./images/charitable-donations.svg").default,
  CheaperThanAgents: require("./images/cheaper-than-agents.svg").default,
  CurveBottom: require("./images/curve-bottom.svg").default,
  CurveTop: require("./images/curve-top.svg").default,
  DarkBlueGradient: require("./images/dark-blue-gradient.svg").default,
  HillsBottom: require("./images/hills-bottom.svg").default,
  HillsComplete: require("./images/hills-complete.svg").default,
  HillsNoNotch: require("./images/hills-no-notch.svg").default,
  HillsTop: require("./images/hills-top.svg").default,
  HillsWithWhiteNotchLarge: require("./images/hills-with-white-notch-large.svg")
    .default,
  HillsWithWhiteNotchMedium:
    require("./images/hills-with-white-notch-medium.svg").default,
  HillsWithWhiteNotch: require("./images/hills-with-white-notch.svg").default,
  HillsNotchExtended: require("./images/hills_notch_extended.svg").default,
  HomepagePullquote: require("./images/homepage-pullquote.svg").default,
  LightBlueGradient: require("./images/light-blue-gradient.svg").default,
  OpenBeta: require("./images/open_beta.svg").default,
  PartialRefunds: require("./images/partial-refunds.svg").default,
  Success: require("./images/success.svg").default,
  TalentSourcers: require("./images/talent-sourcers.svg").default,
};

export const Landingpages = {
  FeatureNetwork: require("./landingpages/feature-network.svg").default,
  FixRecruiting: require("./landingpages/fix-recruiting.svg").default,
};

export const Logos = {
  FrameHiIdent: require("./logos/higher_frame_hi_ident.svg").default,
  FrameHiIdentReversed: require("./logos/higher_frame_hi_ident_reversed.svg")
    .default,
  Frame: require("./logos/higher_frame_logo.svg").default,
  FrameCopy: require("./logos/higher_frame_logo_copy.svg").default,
  PrimaryHiIdent: require("./logos/higher_primary_hi_ident.svg").default,
  PrimaryHiIdentNoMargin:
    require("./logos/higher_primary_hi_ident_no_margin.svg").default,
  PrimaryHiIdentReversed:
    require("./logos/higher_primary_hi_ident_reversed.svg").default,
  PrimaryHiIdentTagline: require("./logos/higher_primary_hi_ident_tagline.svg")
    .default,
  PrimaryHiIdentTaglineReversed:
    require("./logos/higher_primary_hi_ident_tagline_reversed.svg").default,
  PrimaryHiIdentUrl: require("./logos/higher_primary_hi_ident_url.svg").default,
  PrimaryHiIdentUrl1: require("./logos/higher_primary_hi_ident_url_1.svg")
    .default,
  PrimaryHiIdentUrlReversed:
    require("./logos/higher_primary_hi_ident_url_reversed.svg").default,
  PrimaryHiIdentUrlReversed1:
    require("./logos/higher_primary_hi_ident_url_reversed_1.svg").default,
  PrimaryHiIdentUrlTaglineUppercase:
    require("./logos/higher_primary_hi_ident_url_tagline_uppercase.svg")
      .default,
  PrimaryHiIdentUrlTaglineUppercaseReversed:
    require("./logos/higher_primary_hi_ident_url_tagline_uppercase_reversed.svg")
      .default,
  Primary: require("./logos/higher_primary_logo.svg").default,
  PrimaryCentered: require("./logos/higher_primary_logo_centered.svg").default,
  PrimaryCenteredOpenbeta:
    require("./logos/higher_primary_logo_centered_openbeta.svg").default,
  PrimaryNoMargin: require("./logos/higher_primary_logo_no_margin.svg").default,
  PrimaryReversed: require("./logos/higher_primary_logo_reversed.svg").default,
  PrimaryReversedNoMargin:
    require("./logos/higher_primary_logo_reversed_no_margin.svg").default,
  PrimaryTagline: require("./logos/higher_primary_logo_tagline.svg").default,
  PrimaryTaglineReversed:
    require("./logos/higher_primary_logo_tagline_reversed.svg").default,
  PrimaryTaglineUppercase:
    require("./logos/higher_primary_logo_tagline_uppercase.svg").default,
  PrimaryTaglineUppercaseReversed:
    require("./logos/higher_primary_logo_tagline_uppercase_reversed.svg")
      .default,
  PrimaryTaglineUrl: require("./logos/higher_primary_logo_tagline_url.svg")
    .default,
  PrimaryTaglineUrlReversed:
    require("./logos/higher_primary_logo_tagline_url_reversed.svg").default,
  PrimaryUrl: require("./logos/higher_primary_logo_url.svg").default,
  PrimaryUrl1: require("./logos/higher_primary_logo_url_1.svg").default,
  PrimaryUrlReversed: require("./logos/higher_primary_logo_url_reversed.svg")
    .default,
  PrimaryUrlReversed1: require("./logos/higher_primary_logo_url_reversed_1.svg")
    .default,
  PrimaryUrlTagline: require("./logos/higher_primary_logo_url_tagline.svg")
    .default,
  PrimaryUrlTaglineReversed:
    require("./logos/higher_primary_logo_url_tagline_reversed.svg").default,
};

export const Marque = {
  Marque: require("./marque/higher_brand_marque.svg").default,
  MarqueUrl: require("./marque/higher_brand_marque_url.svg").default,
};

export const Partners = {
  LinkedinTextonlyWhite: require("./partners/linkedin-textonly-white.svg")
    .default,
};

export const Strapline = {
  UpYouGoFuchsia: require("./strapline/higher_up_you_go_strapline_fuchsia.svg")
    .default,
  UpYouGoNavy: require("./strapline/higher_up_you_go_strapline_navy.svg")
    .default,
  UpYouGoReversed:
    require("./strapline/higher_up_you_go_strapline_reversed.svg").default,
};

export const UpArrow = {
  Arrow: require("./upArrow/higher_brand_arrow.svg").default,
  ArrowDown: require("./upArrow/higher_brand_arrow_down.svg").default,
  ArrowMargin: require("./upArrow/higher_brand_arrow_margin.svg").default,
  ArrowMarginNavy: require("./upArrow/higher_brand_arrow_margin_navy.svg")
    .default,
  ArrowRight: require("./upArrow/higher_brand_arrow_right.svg").default,
  ArrowRightWhite: require("./upArrow/higher_brand_arrow_right_white.svg")
    .default,
};

export const Url = {
  UrlMark: require("./url/higher_url_mark.svg").default,
  UrlMarkReversed: require("./url/higher_url_mark_reversed.svg").default,
};

const imagery = {
  Animations,
  Callout,
  Faces,
  Icons,
  Images,
  Landingpages,
  Logos,
  Marque,
  Partners,
  Strapline,
  UpArrow,
  Url,
};

export default imagery;
